{
  "version": 1,
  "asset_id": "a9522bdc-6057-4868-9058-c2135890da44",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/a9522bdc-6057-4868-9058-c2135890da44/ewelina-sasin.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/a9522bdc-6057-4868-9058-c2135890da44/ewelina-sasin.jpg",
  "original_filename": "ewelina-sasin.jpg",
  "size": 45186,
  "content_type": "image/jpeg",
  "created_at": "2026-10-02T13:14:16Z"
}
